import type { DragLocationHistory } from '@atlaskit/pragmatic-drag-and-drop/types';
import {
	MAXIMUM_COLUMN_WIDTH,
	MINIMUM_COLUMN_WIDTH,
	MINIMUM_COLUMN_WIDTH_COMPACT,
	MINIMUM_MERGED_CELL_COLUMN_WIDTH,
	SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH,
} from '../../../../common/constants.tsx';

const CSS_RESIZING_WIDTH_PROPERTY = '--local-resizing-width';
const CSS_RESIZING_OFFSETX_PROPERTY = '--local-resizing-offset';

export const setCssResizingOffset = (container: HTMLElement | null, width: number) => {
	container?.style.setProperty(CSS_RESIZING_OFFSETX_PROPERTY, `${width}px`);
};
export const clearCssResizingOffset = (container: HTMLElement | null) => {
	container?.style.removeProperty(CSS_RESIZING_OFFSETX_PROPERTY);
};

export const setCssResizingWidth = (container: HTMLElement | null, width: number) => {
	container?.style.setProperty(CSS_RESIZING_WIDTH_PROPERTY, `${width}px`);
};
export const clearCssResizingWidth = (container: HTMLElement | null) => {
	container?.style.removeProperty(CSS_RESIZING_WIDTH_PROPERTY);
};

export const disableCssPointerEvents = (container: HTMLElement | null | undefined) => {
	container?.style.setProperty('pointer-events', 'none');
};
export const enableCssPointerEvents = (container: HTMLElement | null | undefined) => {
	container?.style.removeProperty('pointer-events');
};

export const ensureWidthWithinLimits = (
	width: number,
	isCompactColumnEnabled?: boolean,
	isSingleLineRowHeightEnabled?: boolean,
	isMultiColumnMergedCell?: boolean,
	mergedColumnMinWidth?: number,
) => {
	let minColumnWidth;
	if (isMultiColumnMergedCell) {
		minColumnWidth = mergedColumnMinWidth || MINIMUM_MERGED_CELL_COLUMN_WIDTH;
	} else {
		minColumnWidth = isSingleLineRowHeightEnabled
			? SINGLE_LINE_ROW_HEIGHT_MINIMUM_COLUMN_WIDTH
			: MINIMUM_COLUMN_WIDTH;
	}
	return Math.min(
		Math.max(isCompactColumnEnabled ? MINIMUM_COLUMN_WIDTH_COMPACT : minColumnWidth, width),
		MAXIMUM_COLUMN_WIDTH,
	);
};

export const getProposedWidth = ({
	initialWidth,
	isCompactColumnEnabled,
	location,
	isSingleLineRowHeightEnabled,
	isMultiColumnMergedCell,
	mergedColumnMinWidth,
}: {
	initialWidth: number;
	isCompactColumnEnabled?: boolean;
	location: DragLocationHistory;
	isSingleLineRowHeightEnabled?: boolean;
	isMultiColumnMergedCell?: boolean;
	// TODO: Make this required when refactor_issue_table_for_timline is being cleaned up
	mergedColumnMinWidth?: number;
}): number => {
	const diffX = location.current.input.clientX - location.initial.input.clientX;
	const proposedWidth = initialWidth + diffX;

	// ensure we don't go below the min allowed width
	return ensureWidthWithinLimits(
		proposedWidth,
		isCompactColumnEnabled,
		isSingleLineRowHeightEnabled,
		isMultiColumnMergedCell,
		mergedColumnMinWidth,
	);
};
